<div class="login-background">
    <div class="login-center-container">
        <form (ngSubmit)="login()">
            <div class="one-row login-logo-row">
                <div class="vetvet-logo">VETVET<span class="vetvet-dot">.</span></div>
            </div>
            <div class="login-header-block">
                <div class="login-title">Einloggen</div>
                <div class="login-hint">weiter zu vetvet</div>
            </div>
            <div>
                <mat-form-field class="login-form-field" appearance="fill">
                    <mat-label>E-Mail</mat-label>
                    <span matPrefix class="login-form-prefix">
                        <mat-icon>email</mat-icon>
                        &nbsp;
                    </span>
                    <input
                        #emailInput
                        [formControl]="emailCtrl"
                        autocomplete="username"
                        data-cy="login-email"
                        matInput
                        type="email"
                    />
                </mat-form-field>
                <mat-form-field class="login-form-field" appearance="fill">
                    <mat-label>Passwort</mat-label>
                    <span matPrefix class="login-form-prefix">
                        <mat-icon>more_horiz</mat-icon>
                        &nbsp;
                    </span>
                    <input
                        #passwordInput
                        [formControl]="passwordCtrl"
                        [type]="hidePassword ? 'password' : 'text'"
                        autocomplete="current-password"
                        data-cy="login-password"
                        matInput
                        type="password"
                    />
                    <mat-icon (click)="hidePassword = !hidePassword" matSuffix>
                        {{ hidePassword ? "visibility" : "visibility_off" }}
                    </mat-icon>
                </mat-form-field>
                <div>
                    <button
                        [disabled]="isLoading"
                        color="primary"
                        data-cy="login-submit"
                        mat-flat-button
                        class="login-submit-btn"
                        type="submit"
                    >
                        Anmelden
                    </button>
                    <div class="login-links-row login-links-row-right">
                        <button
                            (click)="resetPassword()"
                            mat-button
                            type="button"
                            class="login-link-btn login-link-btn-small"
                        >
                            <span class="kiene-color login-link-btn-small-text">Passwort vergessen?</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
        <div class="login-legal-links">
            <a href="https://www.vetvet.de/impressum" target="_blank" class="login-legal-link">Impressum</a>
            <span class="login-legal-separator">·</span>
            <a href="https://www.vetvet.de/datenschutz" target="_blank" class="login-legal-link">Datenschutz</a>
            <span class="login-legal-separator">·</span>
            <a href="https://www.vetvet.de/agb" target="_blank" class="login-legal-link">AGB</a>
        </div>
        <div class="login-register-row">
            <hr class="login-register-hr" />
            <span class="login-register-hint">Sie haben noch kein Konto? </span>
            <button (click)="register()" mat-button type="button" class="login-link-btn login-register-btn">
                <span class="kiene-color">Registrieren</span>
            </button>
        </div>
    </div>
</div>
